<template>
	<div class="print_container full">
		<div class="print_header flex">
			<el-button type="primary" v-print="printObj" size="mini">打印</el-button>
			<el-button type="success" @click="download" size="mini">下载</el-button>
		</div>
		<div class="print full" ref="print_container">
			<div>
				<div class="print_paper" style="width: 900px;border: none;">
					<div class="print_content" id="print_content" ref="printContent"
						style="-webkit-print-color-adjust: exact;width: 1000px;">
						<div>
							<div class="body" style="padding-bottom: 64px;">
								<table class="row" style="line-height: 22px;margin-top: 32px;padding: 0;width: 850px;">
									<thead>
										<tr >
											<th colspan="9" style="width: 850px;text-align: center;">付款申请书</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{this.$Moment(this.formdata.commit_time).format('YYYY年MM月DD日')}}</span>
												</div>
											</td>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{formdata.code}}</span>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>收款单位</span>
												</div>
											</td>
											<td colspan="5">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{formdata.rcvName}}</span>
												</div>
											</td>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>付款原因</span>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>付款单位</span>
												</div>
											</td>
											<td colspan="5">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{formdata.accName}}</span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>供应商</span>
												</div>
											</td>
											<td colspan="2">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{formdata.supplier}}</span>
												</div>
											</td>
										</tr>										
										<tr>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>开户行</span>
												</div>
											</td>
											<td colspan="5">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<!-- <span>{{this.$Moment(this.formdata.commit_time).format('M月')}}</span> -->
													<span>{{formdata.mark}}</span>
												</div>
											</td>
											<td colspan="2">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{formdata.purchasesum}}</span>
												</div>
											</td>
										</tr>										
										<tr>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>金额</span>
												</div>
											</td>
											<td colspan="5">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="2">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
										</tr>	
										<tr>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>附件{{formdata.img_file.length}}张</span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>¥</span>
												</div>
											</td>
											<td colspan="4">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="2">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
										</tr>
										<tr>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>审批</span>
												</div>
											</td>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>财务</span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
											<td colspan="2">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span></span>
												</div>
											</td>
										</tr>																													
										<tr>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>经办人 {{getstaff(this.formdata.staffid)}}</span>
												</div>
											</td>
											<td colspan="3">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>审批人 张建存</span>
												</div>
											</td>
											<td colspan="1">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>合计</span>
												</div>
											</td>
											<td colspan="2">
												<div class="flex" style="flex-direction: row;font-size: 14px;">
													<span>{{formdata.purchasesum}}</span>
												</div>
											</td>
										</tr>																													
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
	table {
		width: 100%;
		border-collapse: collapse;
	}

	table,
	th,
	td {
		border: 1px solid black;
		/* 设置边框颜色为白色 */
	}

	table.tableinfo_3 {
		border: none;

	}

	table.tableinfo_3 td {
		padding: 2px;
		text-align: left;
		border: none;
		font-size: 14px;
		/* Remove borders for td and th within .tableinfo */
	}

	table.goodsinfo_3 th,
	table.goodsinfo_3 td {
		padding: 2px;
		font-size: 14px;
		text-align: center;

		/* Remove borders for td and th within .tableinfo */
	}

	.row {
		position: relative;
		width: 100%;
		font-size: 16px;
		line-height: 32px;
		display: inline-block;
		box-sizing: border-box;
	}

	.content {
		border-bottom: 1px solid black;
		flex: 1;
	}

	.print_content {
		box-sizing: border-box;
		padding: 20px;
	}

	.header {
		position: relative;
		width: 100%;
		color: black;
		top: 0;
		flex-direction: row;
		align-items: flex-end;
		box-sizing: border-box;
		margin: 10px 0;
		margin-bottom: 20px;
	}

	.header_notice {
		font-size: 14px;
		margin-right: 40px;
	}

	.header_title {
		font-size: 24px;
		font-weight: bold;
		margin-left: 10px;
	}

	.body_part2 {
		font-size: 12px;
		box-sizing: border-box;
		padding: 10px;

	}

	.body_part3 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
		margin-top: 20px;
	}

	.body_part4 {
		font-size: 14px;
		box-sizing: border-box;
		padding: 10px;
	}

	.ma {
		width: 60px;
		height: 60px;
	}
</style>
<style>
	.print-col-black {
		background-color: black;
		color: #fff;

	}
</style>
<script>
	// import vueQr from 'vue-qr'
	import html2canvas from 'html2canvas';
	export default {
		props: {
			formdata: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				contentMode: "normal",
				loading: true,
				ma: null,
				printObj: {
					id: "print_content", // 这里是要打印元素的ID
					popTitle: "&nbsp", // 打印的标题
					extraCss: '', // 打印可引入外部的一个 css 文件
					extraHead: "", // 打印头部文字
					preview: false,
					previewTitle: '报价单预览'
				},
				department: '',
				collection: '',
				companyaddress: '',
				mark: '',
				staffinfo: null,
				director: [],
				tableData: [],
				couponData: [],
				price: 0,
				amount: 0,
				showamount: 0,
				infoData: {},
				customeraddress: '',
				form: {
					server: []
				},
			}
		},
		created() {

		},
		mounted() {
			this.init()

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getEmunValue(field, value) {
				return window.systemMethods.getEmunValue(field, value)
			},
			// initdata() {
			// 	let handle = this.$loading(this.$refs.print_container)
			// 	return new Promise((reslove) => {
			// 		this.$api.order.get(this.id, {
			// 			controlltype: 3
			// 		}).then((res) => {
			// 			this.mainData = res
			// 			this.$api.order.list({
			// 				id: this.id,
			// 				son: 'order_goods',
			// 				with:['outboundorder','old2new']
			// 			}).then((res) => {
			// 				this.tableData = res.list
			// 				this.$api.order.list({
			// 					id: this.id,
			// 					son: 'order_coupon'
			// 				}).then((res) => {
			// 					this.couponData = res.list
			// 					reslove()
			// 					this.$loadingclose(handle)
			// 				})
			// 			})
			// 		})
			// 	})
			// },
			init() {
				console.log(this.formdata)
			},

			getwarehouse(warehouseid) {
				return window.systemMethods.getwarehouse(warehouseid)
			},
			getstaff(staffid) {
				return window.systemMethods.getstaff(staffid)
			},
			getdepartment(departmentid) {
				return window.systemMethods.getdepartment(departmentid)
			},
			headerCellClassName() {
				return 'print-col-black'
			},
			download() {
				html2canvas(this.$refs.printContent, {
					scale: 2,
					useCORS: true
				}).then((canvas) => {
					this.convertCanvasToImg(canvas)
				})
			},
			convertCanvasToImg(canvas) {
				let myBlob = this.dataURLtoBlob(canvas.toDataURL('img/png', 0.92))
				let myUrl = URL.createObjectURL(myBlob)
				this.downImg(myUrl)
			},
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},
			downImg(url) {
				let a = document.createElement("a")
				let clickEvent = document.createEvent("MouseEvents")
				a.setAttribute("href", url)
				a.setAttribute("download", "定金单")
				a.setAttribute("target", '_blank')
				clickEvent.initEvent('click', true, true)
				a.dispatchEvent(clickEvent)
			},
			back() {
				this.$emit('back')
			}
		},
		components: {
			// vueQr
		}
	}
</script>